<template>
<body style="background-color:#e6f0f5;">
  <a @click="add(0)">
    <div class="teavel_person_header">
      <span>
        <img alt src="@/assets/images/customer/add_person_03.png">
      </span>
      <p>新增{{typeName}}</p>
      <img alt src="@/assets/images/customer/rightarrow3_03.png">
    </div>
  </a>
  <div class="teavel_person_list">
    <div v-if="travel_person_list.length > 0">
      <div class="teavel_person_line" v-for="(travel_person_info, index) in travel_person_list">
        <span :class="{sel_cls: num==index}" @click="sel(index)">
          <img src="@/assets/images/html/blue_draw_03.png" v-show="index==num">
        </span>
        <em>{{travel_person_info.name}}</em>
        <P
          style="width:60%;"
        >（{{travel_person_info.sex + "，" + travel_person_info.nationality + "，" + travel_person_info.person_type_name}}）</P>
        <a @click="add(travel_person_info.member_id)" href="javascript:void(0);">
          <img alt src="@/assets/images/customer/update_person_03.png">
        </a>
      </div>
    </div>

    <!-- <div id="loading">Loading...</div> -->
    <!-- <div class="travel_person_height"></div> -->
  </div>
  <div class="teavel_person_submit" style="position: relative;">
    <input @click="confirm" type="button" value="确定">
  </div>
</body>
</template>
<script>
export default {
  name: 'TravelPersonOften',
  componentName: 'TravelPersonOften',
  data () {
    return {
      num: null,
      url: 'member/travel_personList',
      travel_person_list: [],
      searchInfo: {
        member_types: 6,
        source: 'oct',
        who_add: this.$sessionStorageUtil.get('member_id')
      },
      orderInfo: {},
      planInfo: this.$sessionStorageUtil.get('route_order_plan_info'),
      isVisa: false,
      typeName: '办签人',

    }
  },
  props: {
    order_add_info: Object
  },
  created () {
    this.getTravelPersonList();
  },
  methods: {
    add (travel_person_id) {
      if (travel_person_id) {
        this.$domUtils.dispatch(this, 'TravelPerson', 'cut.travel.person', { travel_person_id: travel_person_id, show_often: false })
      } else {
        this.$domUtils.dispatch(this, 'TravelPerson', 'cut.travel.person', { show_often: false })
      }
    },
    confirm () {
      if (this.num != null) {
        let params = {
          sel_id: this.travel_person_list[this.num].member_id,
          sel_name: this.travel_person_list[this.num].name,
          sel_sex: this.travel_person_list[this.num].sex,
          sel_nationality: this.travel_person_list[this.num].nationality,
          sel_person_type: this.travel_person_list[this.num].person_type,
          sel_person_type_name: this.travel_person_list[this.num].person_type_name,
        }
        this.$domUtils.dispatch(this, 'OrderSubmit', 'set.travel.person', [params])
      } else {
        this.$msg('请选择一个办签人', 'info', 3000);
        let params = {
          action: 'sel',
          sel_id: '',
          sel_name: '',
          sel_sex: '',
          sel_nationality: '',
          sel_person_type: '',
          sel_person_type_name: '',
        }
        this.$domUtils.dispatch(this, 'OrderSubmit', 'set.travel.person', [params])
      }
    },
    getTravelPersonList () {
      this.searchInfo['plan_id'] = this.planInfo.route_plan_id
      this.searchInfo['plan_source'] = this.planInfo.source
      var orderAddInfo = this.order_add_info
      if (orderAddInfo.temp_member_id != null) {
        this.searchInfo.who_add = orderAddInfo.temp_member_id
      }
      this.$myGet(this.url, this.searchInfo).then(res => {
        this.travel_person_list = res.response.data.page.records
      })
        .catch(err => {
          console.log('err:' + err)
        })
    },
    sel (index) {
      this.num = index
    }
  }
}
</script>
<style scoped>
@import '../../../assets/css/pages/customer/second_phase.css';
.sel_cls {
  border: 0.2em solid #0d9eff;
}
</style>



// WEBPACK FOOTER //
// src/pages/customer/travel_person/travelPersonOften.vue